module.exports = require("./fr-MA.d.ts");